module.exports = __webpack_public_path__ + "img/error.0358f498.svg";